// extracted by mini-css-extract-plugin
export var card = "styles-module--card--12e84";
export var cards = "styles-module--cards--c84c1";
export var container = "styles-module--container--fc3eb";
export var containerRelative = "styles-module--containerRelative--ac8ce";
export var newsletter = "styles-module--newsletter--be4d8";
export var newsletterBody = "styles-module--newsletterBody--71db0";
export var newsletterInput = "styles-module--newsletterInput--cb2ed";
export var sidebar = "styles-module--sidebar--26ca8";